<template>
    <widget :title="title" :router="router" :class="'widget_level'+widgetType">
        <template slot="choose_info">
            <selectCom :tabList="tabList" @getTab="getTab"></selectCom>
        </template>
        <div class="widget_cont">
            <template v-if="activeName == '我的课程'">
                <div class="class_type" v-if="widgetType != 2">
                    <div class="class_list" @click="traingIndex()">
                        <span class="float_right">{{traintingData.myCourse.credit || 0}}</span>
                        <span>学分</span>
                    </div>
                    <div class="class_list" @click="traingIndex">
                        <span class="float_right">{{traintingData.myCourse.learning || 0}}</span>
                        <span>进行中</span>
                    </div>
                    <div class="class_list" @click="traingIndex">
                        <span class="float_right">{{traintingData.myCourse.learnCenter || 0}}</span>
                        <span>已学</span>
                    </div>
                    <div class="class_list" v-if="widgetType!=1" @click="traingIndex()">
                        <span>学习中心</span>
                        <span class="float_right default_bar">进入>></span>
                    </div>
                </div>
                <div class="lists">
                    <div class="list_cont" v-for="(item,index) in traintingData.myCourse.courseList" :key="index">
                        <span class="tag">{{item.xuanxiu}}</span>
                        <div class="list_name" @click="traingIndex">{{item.title}}</div>
                        <div class="percentage_item" v-if="widgetType != 2">
                            <span class="per_val">已获学分：{{item.credit}}</span>
                            <span class="per_info">完成率：{{item.percent}}%</span>
                            <div class="percentage" v-if="widgetType == 3"><div :style="'width:'+item.percent+'%;background:-webkit-linear-gradient(to right,#1B67F0,#5CC0F8);background:-o-linear-gradient(to right,#1B67F0,#5CC0F8);background:-moz-linear-gradient(to right,#1B67F0,#5CC0F8);background:linear-gradient(to right,#1B67F0,#5CC0F8);'"></div></div>
                        </div>
                        <div class="percentage_item" v-else>
                            <div class="percentage" v-if="color[index]"><div :style="'width:'+item.percent+'%;background:-webkit-linear-gradient(to right,'+color[index][0]+','+color[index][1]+');background:-o-linear-gradient(to right,'+color[index][0]+','+color[index][1]+');background:-moz-linear-gradient(to right,'+color[index][0]+','+color[index][1]+');background:linear-gradient(to right,'+color[index][0]+','+color[index][1]+');'"></div></div>
                            <span class="per_info">完成率：{{item.percent}}%</span>
                            <span class="per_val">已获学分：{{item.credit}}</span>
                        </div>
                    </div>
                </div>
            </template>
            <template v-if="activeName == '自学推荐'">
                <div class="lists tab_second">
                    <div class="list_cont" v-for="(item,index) in traintingData.activeLearn" :key="index">
                        <span class="tag">推荐</span>
                        <div class="list_name" @click="traingVideoDetail(item)">{{item.resourceTitle}}</div>
                        <div class="percentage_item">
                            <span class="per_info">格式：{{item.resourceTitle | format}}</span>
                            <span class="per_val">播放数：{{item.playTimes || 0}}</span>
                        </div>
                    </div>
                </div>
            </template>
        </div>
    </widget>
</template>
<script>
    import widget from './warp'
    import selectCom from './select'
    import widgetFilter from './widgetFilter.js'
    export default {
        components: {
            widget,
            selectCom
        },
        props:{
            title:{
                type:String
            },
            swWidth:{
                type:Number,
                default:1
            },
            item:{
                type:Object
            }
        },
        filters:{
            format:function(val){
                return '.'+val.split('.')[1]
            }
        },
        data(){
            return {
                widgetType:1,
                router:'training_learn_index',
                traintingData:{
                    myCourse:{
                        courseList:[]
                    },
                    activeLearn:[]
                },
                tabFirst:{},
                tabSecond:{},
                tabList:['我的课程','自学推荐'],
                activeName:'我的课程',
                color:[
                    ['#10D9D2','#21E8AD'],
                    ['#2582F4','#35A9F9'],
                    ['#F0B41B','#E6DE07'],
                    ['#D335F3','#FF76B4'],
                    ['#26E9A9','#E3E703'],
                    ['#10D9D2','#21E8AD'],
                ],
                configList:null,
            }
        },
        mounted(){
            let vm = this
            vm.$nextTick(function(){
                vm.widgetType = _.cloneDeep(vm.swWidth)
                if(vm.item.configList.length > 0){
                    let configList = vm.item.configList
                    vm.configList = widgetFilter.getFieldMap(configList)
                    // console.log("---------",vm.configList)
                    let stemp = []
                    for(let i in vm.configList){
                        stemp.push(vm.configList[i])
                    }
                    let widgetUrl = stemp[0].apiUrl
                    vm.query(widgetUrl)
                }
            })
           
        },
        methods: {
            query(widgetUrl){
                let vm = this
                http.get(widgetUrl).then(function(xhr){
                    let objectA = xhr.data
                    let simpleMap = widgetFilter.getFieldMap(vm.item.columns)
                    // console.log("===========",simpleMap)
                    var newObj = new Object();
                    vm.traintingData = widgetFilter.showProps(objectA,'',simpleMap,newObj)
                    console.log("===========",vm.traintingData)
                })
            },
            getTab(data){
                this.activeName = data
            },
            traingIndex(){
                let par = {
                    breadcrumb: [{name: '我的培训', component: this.router}]
                }
                this.$irouter({name: this.router, param: par});
            },
            traingVideoDetail(item){
                let par = {
                    activityId: item.courseActivityId,
                    courseId: item.courseId,
                    id: item.id,
                    isAdd: 1,
                    resourceId: item.cover,
                    breadcrumb: [{name: '视频播放', component: 'training_active_learn_video_detail'}]
                }
                this.$irouter({name: 'training_active_learn_video_detail', param: par});
            },
            nodeSplicing(){
                let irouter = widgetFilter.nodeSplicing(arguments[0],this.configList,this.simpleMap)
                if(irouter)
                this.$irouter(irouter)
            }
        }
    }
</script>
<style scoped lang="less">
    .widget_cont{
        position: relative;
        overflow: hidden;
        height: 270px;
        .setting_btn{
            position: absolute;top: 95px;right:0;
            color: #4183fc;
            i{
                margin-right: 8px;
            }
        }
    }
    .class_type{
        display: flex;
        flex-wrap: nowrap;
        justify-content: space-between;
        margin: 18px 0 10px 0;
        .class_list{
            flex: 1;
            margin: 0 10px;
            height: 66px;
            color:#fff;
            border-radius:6px;
            padding:16px 22px;
            box-sizing:border-box;
            line-height:34px;
            cursor: pointer;
            span{
                font-size: 16px;
            }
            .float_right{
                font-size: 24px;
                font-weight: bold;
            }
            .default_bar{
                font-size: 18px;
            }
        }
        .class_list:first-child{
            margin-left: 0;
        }
        .class_list:last-child{
            margin-right: 0;
        }
    }
    .lists{
        padding-bottom: 20px;
        .list_cont{
            float: left;
            font-size:12px;
            color:#666;
            .tag{
                background: #EDF3FE;
                border-radius:50%;
                font-size:12px;
                padding:0 5px;
                color:#666;
                height: 40px;
                min-width: 40px;
                line-height: 40px;
                text-align: center;
            }
            .list_name{
                line-height: 20px;
                font-size: 14px;
                font-weight: bold;
                overflow:hidden;
                text-overflow:ellipsis;
                white-space:nowrap;
                margin-left: 16px;
                margin-right: 40px;
                color: #333;
                cursor: pointer;
            }    
            .percentage_item{
                display: flex;
                margin-top:2px;
                line-height: 18px;
            }  
            .percentage{
                height: 6px;
                background: #E5E7EA;
                border-radius: 3px;
                flex-grow: 1;
                margin-top: 7px;
                div{
                    height: 100%;
                    border-radius: 3px;
                }
            }
            .per_info{
                margin-left: 16px;
            }
            .per_val{
                margin-left: 16px;
            }
        }
    }
    .lists.tab_second{
        .list_cont{
            .tag{
                color: #fff;
                background:-webkit-linear-gradient(to right,#1B67F0,#5CC0F8);
                background:-o-linear-gradient(to right,#1B67F0,#5CC0F8);
                background:-moz-linear-gradient(to right,#1B67F0,#5CC0F8);
                background:linear-gradient(to right,#1B67F0,#5CC0F8);
            }
            .percentage_item{
                width: auto;
            }
            .list_name{
                width: auto;
                flex-grow: 1;
            }
        }
    }
    .widget_level1{
        .tab_second{
            padding-top: 4px;
        }
        .class_type{
            text-align: center;
            span{
                display: block;
                line-height: 23px;
                font-size: 12px;
            }
            .float_right{
                float: none;
                font-size: 12px;
            }
            .class_list{
                padding: 5px 10px;
                height: 55px;
            }
            .class_list:nth-child(1){
                background:linear-gradient(#3BB7FB,#1965F0);
                background:-webkit-linear-gradient(#3BB7FB,#1965F0);
                background:-o-linear-gradient(#3BB7FB,#1965F0);
                background:-moz-linear-gradient(#3BB7FB,#1965F0);
            }
            .class_list:nth-child(2){
                background:linear-gradient(#EBEE0E,#F8922D);
                background:-webkit-linear-gradient(#EBEE0E,#F8922D);
                background:-o-linear-gradient(#EBEE0E,#F8922D);
                background:-moz-linear-gradient(#EBEE0E,#F8922D);
            }
            .class_list:nth-child(3){
                background:linear-gradient(#24EAA6,#02CEF1);
                background:-webkit-linear-gradient(#24EAA6,#02CEF1);
                background:-o-linear-gradient(#24EAA6,#02CEF1);
                background:-moz-linear-gradient(#24EAA6,#02CEF1);
            }
        }
        .lists{
            .tag{
                float: left;
            }
            .percentage{
                margin-left: 30px;
            }
            .list_name{
                margin-left: 56px;
            }
            .list_cont{
                margin: 24px 0;
                float: none;
            }
            
        }
    }
    .widget_level2{
        .lists{
            .list_cont{
                display: flex;
                float: none;
                margin-top:30px;
            }
            .tag{
                flex-shrink: 0;
                height: 20px;
                line-height: 20px;
                border-radius: 3px;
            }
            .list_name{
                width: 30%;
            }
            .percentage_item{
                flex-grow: 1;
                flex-shrink: 0;
            }
        }
        .tab_second{
            .percentage_item{
                flex-grow: 0;
            }
        }
    }
    .widget_level3{
        .class_type{
            margin: 18px 0 4px 0;
            .class_list:nth-child(1){
                background:url(../img/widget/ico6.png);
                background-size: 100% 100%;
            }
            .class_list:nth-child(2){
                background:url(../img/widget/ico7.png);
                background-size: 100% 100%;
            }
            .class_list:nth-child(3){
                background:url(../img/widget/ico8.png);
                background-size: 100% 100%;
            }
            .class_list:nth-child(4){
                background:url(../img/widget/ico9.png);
                background-size: 100% 100%;
            }
        }
        .tab_second{
            padding-top: 24px;
        }
        .lists{
            .tag{
                float: left;
            }
            .percentage{
                margin-left: 30px;
            }
            .list_name{
                margin-left: 56px;
            }
            .list_cont{
                margin: 12px 0;
                width:50%;
            }
            .list_cont:nth-child(2n+1){
                padding-right: 20px;
            }
            .list_cont:nth-child(2n+2){
                padding-left: 20px;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/homepage/widget/training.vue